export type BeneficiarioItem = {
	cdUsuario: string;
	nmPessoaRazaoSocial: string;
	nmSocial: string | null;
	cpf: string | null;
	vlMensalidade: number;
	vlCoparticipacao: number;
};

export type ObrigacaoPendente = {
	cdObrigacao: number;
	cdEspecieTitulo: number;
	cdStatus: number;
	dsStatus: string;
	dtVencimento: string;
	dtPrevista: string;
	dtCompInicio: string;
	dtCompFim: string;
	vlObrigacao: string | number;
	cdDocumentoGerador: string;
	cdDocumentoControle: string;
	qtDiasBaixa: number;
	dtEmissao: number;
	flMigracao: boolean;
	urlBoletoMigrado: string | null;
	cdObrigacaoOrigem: number;
	cdEmpresaParceira: number | null;
	vlJuros: string | number;
	vlMulta: string | number;
	vlDesconto: string | number;
	vlTotalCoparticipacao: string;
	cdBarra: string | null;
	vlAtualizado: string | number;
	qtdDiasAtraso: number;
	beneficiarios: BeneficiarioItem[];
	interestAmount: string;
	fineAmount: string;
	discountAmount: string;
};

export enum RecurrenceTypeEnum {
	CREDIT = 'CARD',
	CREDIT_CIELO = 'CARD_CIELO',
	CREDIT_BRASPAG = 'CARD_BRASPAG',
	DEBIT = 'DEBIT',
	BILL = 'BOLETO',
	PIX = 'PIX',
}

export type GetInvoicesModel = {
	email: string;
	telefone: string;
	flFaturaDigital: boolean;
	flDebitoAutomatico: boolean;
	flRecorrencia: boolean;
	tipoRecorrencia: RecurrenceTypeEnum;
	obrigacoesPendentes: ObrigacaoPendente[];
};

export type GetInvoicesParams = {
	signal?: AbortSignal;
};

export interface GetInvoices {
	get: (params?: GetInvoicesParams) => Promise<GetInvoicesModel>;
}
